import React from 'react'

interface CardProps {
  title?: string
  subtitle?: string
  imageUrl?: string
  description?: string
  'data-id'?: string
}

// Single Card Component
export function Card({
  title = 'Plano East Senior High School',
  subtitle = '',
  imageUrl = 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
  description = 'Plano East Senior High School\nPresident: Ayan Mishra\nVice-President:',
  'data-id': dataId,
}: CardProps) {
  return (
    <div
      className="relative w-full max-w-sm mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden font-['Figtree']"
      data-id={dataId}
    >
      {/* Background Image with Overlay */}
      <div
        className="relative h-96 bg-cover bg-center"
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/60" />
        {/* Title and Subtitle */}
        <div className="absolute bottom-4 left-4 text-white">
          <h2 className="text-4xl font-bold mb-1">{title}</h2>
          <p className="text-lg opacity-90">{subtitle}</p>
        </div>
      </div>
      {/* Description Section */}
      <div className="p-4">
        <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">{description}</p>
      </div>
    </div>
  )
}

// Card List Component
interface CardListProps {
  cards: CardProps[]
}

export function CardList({ cards }: CardListProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
      {cards.map((card, index) => (
        <Card
          key={card['data-id'] || index}
          title={card.title}
          subtitle={card.subtitle}
          imageUrl={card.imageUrl}
          description={card.description}
          data-id={card['data-id']}
        />
      ))}
    </div>
  )
}